<template>
  <div class="application-question-templates settings-templates">
    <EditApplicationQuestionTemplateDialog
      :applicationQuestionTemplate="currentApplicationQuestionTemplate"
      :isOpen="isOpen"
      @close="closeDialog"
    />
    <div class="container col-lg-8 col-sm-12 mb-12">
      <BaseListToolbar
        title="Application Questions"
        @search="updateSearchValue"
        hideSearchBar
      />
      <div v-if="isFetchingOrganisationApplicationQuestionTemplates">
        <v-skeleton-loader v-for="i in 5" :key="i" s type="list-item-avatar" />
      </div>
      <div v-else>
        <v-list-item
          v-for="applicationQuestionTemplate in applicationQuestionTemplates"
          :key="applicationQuestionTemplate.id"
          @click="handleSelect(applicationQuestionTemplate)"
        >
          <ApplicationQuestionTemplateItem
            :applicationQuestionTemplate="applicationQuestionTemplate"
          />
        </v-list-item>
      </div>
      <v-pagination
        :total-visible="page.pageSize"
        v-if="showPagination"
        v-model="page.currentPage"
        @input="loadApplicationQuestionTemplates"
        :length="page.lastPage"
      />
      <BaseFooter>
        <NewApplicationQuestionTemplateAction @refresh="refreshPage" />
      </BaseFooter>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { ORGANISATION_APPLICATION_QUESTION_TEMPLATES_NAMESPACE } from "@/store/modules/organisations/organisation-application-question-templates";
import { FETCH_APPLICATION_QUESTION_TEMPLATES } from "@/store/modules/organisations/organisation-application-question-templates/actions";
import { copyState } from "@/utils/helpers";
import ApplicationQuestionTemplateItem from "@/views/settings/components/application-question-templates/components/ApplicationQuestionTemplateItem";
import BaseListToolbar from "@/components/common/Toolbar/BaseListToolbar";
import { paginationMixin } from "@/mixins/pagination.mixin";
import BaseFooter from "@/components/common/BaseFooter";
import NewApplicationQuestionTemplateAction from "./components/actions/NewApplicationQuestionTemplateAction";
import EditApplicationQuestionTemplateDialog from "./components/dialogs/EditApplicationQuestionTemplateDialog";

const { mapActions, mapState } = createNamespacedHelpers(
  ORGANISATION_APPLICATION_QUESTION_TEMPLATES_NAMESPACE
);

export default {
  name: "ApplicationQuestionTemplates",
  mixins: [paginationMixin],
  components: {
    ApplicationQuestionTemplateItem,
    BaseListToolbar,
    BaseFooter,
    NewApplicationQuestionTemplateAction,
    EditApplicationQuestionTemplateDialog
  },
  created() {
    this.loadApplicationQuestionTemplates();
  },
  data() {
    return {
      isOpen: false,
      currentApplicationQuestionTemplate: {},
      searchText: ""
    };
  },
  computed: {
    ...mapState(
      copyState([
        "organisationApplicationQuestionTemplates",
        "isFetchingOrganisationApplicationQuestionTemplates"
      ])
    ),
    applicationQuestionTemplates() {
      return this.organisationApplicationQuestionTemplates;
    },
    requestParams() {
      return {
        filter: {
          // TODO uncomment after api improvements
          // ...(size(this.searchText) && { question: this.searchText })
        },
        ...this.requestPageParams
      };
    }
  },
  methods: {
    ...mapActions({
      fetchApplicationQuestionTemplates: FETCH_APPLICATION_QUESTION_TEMPLATES
    }),
    handleSelect(template) {
      this.currentApplicationQuestionTemplate = template;
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
      this.refreshPage();
    },
    refreshPage() {
      this.resetPagination();
      this.loadApplicationQuestionTemplates();
    },
    async loadApplicationQuestionTemplates() {
      const data = await this.fetchApplicationQuestionTemplates(
        this.requestParams
      );
      if (data) {
        this.updatePageDetails(data.meta);
      }
    },
    updateSearchValue(text) {
      this.searchText = text;
      this.resetPagination();
      this.loadApplicationQuestionTemplates();
    }
  }
};
</script>

<style lang="scss"></style>
